module.exports = __webpack_public_path__ + "static/media/loc1_img33.669a57bb.jpg";